import { View } from 'react-native';

import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';
import { Card } from '@/components/ui/therapist/Card';
import { User } from '@/stores/store.types';
import { useNavigation } from '@react-navigation/native';

import { styles } from './styles';

interface LoginInfoProps {
  user: User;
}

export const LoginInfo: React.FC<LoginInfoProps> = ({ user }) => {
  const navigation = useNavigation();

  return (
    <Card
      iconPosition="outside"
      title="Anmeldung & Sicherheit"
      icon="lock"
      styleBody={{ padding: 0 }}
    >
      <View style={[styles.itemContainer, { paddingTop: 20 }]}>
        <Text style={styles.label}>E-Mail</Text>
        <View style={styles.mailWrapper}>
          <Text>{user.email}</Text>
        </View>
      </View>
      <View style={styles.divider}></View>
      <View style={[styles.itemContainer, { paddingBottom: 20 }]}>
        <Text style={styles.label}>Passwort</Text>
        <View style={styles.itemContainer}>
          <Text>********</Text>
          <Button
            icon="edit"
            label="Ändern"
            look="secondary"
            onPress={() => navigation.navigate('PasswordChangeScreen')}
          />
        </View>
      </View>
    </Card>
  );
};
